import React from "react";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { colors } from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import { useHorizontalDragScroll } from "../../utils/useHorizontalDragScroll";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const ProductCards = ({ productData }) => {
  const navigate = useNavigate();
  const ref = useHorizontalDragScroll();
  const isWeb = typeof window !== "undefined" && window.innerWidth > 768;

  const scrollLeft = () => {
    ref.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    ref.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <Box
      ref={ref}
      className="flex overflow-x-auto"
      sx={{
        display: "flex",
        gap: 2,
        pb: 2,
        width: "calc(100vw + 0px)",
        marginLeft: "-20px",
        pl: 2,
        "&::-webkit-scrollbar": {
          display: "none",
        },
        cursor: "pointer",
      }}
    >
      {isWeb && (
        <IconButton
          onClick={scrollLeft}
          sx={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: "white",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
            "&:hover": { backgroundColor: "#f1f1f1" },
          }}
        >
          <ArrowBackIos fontSize="small" sx={{ pl: 0.5 }} />
        </IconButton>
      )}

      {productData.map((product, index) => (
        <Stack
          key={index}
          direction={"column"}
          sx={{
            ml: index === 0 ? 2 : 0,
            mr: index === productData.length - 1 ? 2 : 0,
          }}
        >
          <Card
            onClick={() => {
              navigate("/product", {
                state: {
                  product: product,
                },
              });
            }}
            sx={{
              width: "220px",
              borderRadius: "12px",
              display: "flex",
              flexDirection: "column",
              boxShadow: "-1px -1px 5px 0px #00000012",
              flexShrink: 0,
              position: "relative",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.2)",
              },
              "&:active": {
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                transform: "scale(0.98)",
              },
              minHeight: "480px",
            }}
          >
            {product?.price?.sale_percentage != null && (
              <Box
                sx={{
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                  backgroundColor: "#ABCC8C",
                  color: colors.textColor,
                  borderBottomLeftRadius: "20px",
                  padding: "5px 11px",
                  fontSize: "12px",
                  fontFamily: "Poppins-Bold",
                  zIndex: 1,
                }}
              >
                {Math.round(product?.price?.sale_percentage)} % Off
              </Box>
            )}

            {product?.brand && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: "0px",
                  right: "0px",
                  backgroundColor: "#9DDEEC",
                  borderTopLeftRadius: "20px",
                  padding: "5px 11px",
                  zIndex: 1,
                }}
              >
                {product?.brand}
                {/* <img
                src={product?.brandLogo}
                alt="logo"
                style={{
                  height: "20px",
                  objectFit: "cover",
                }}
              /> */}
              </Box>
            )}

            <img
              src={product?.image_url}
              alt=""
              onError={(e) =>
                (e.target.src = require("../../assets/images/no_image.png"))
              }
              loading="lazy"
              style={{
                objectFit: "cover",
                height: "350px",
              }}
            />

            <CardContent className="bg-white px-2">
              <Typography
                variant="h6"
                sx={{
                  fontSize: "14px",
                  color: colors.textColor2,
                  fontFamily: "Poppins-Bold",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {product?.title}
              </Typography>
              {product?.description && (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "12px",
                    color: colors.textColor2,
                    fontFamily: "Poppins-Light",
                    fontWeight: "400",
                    lineHeight: "15px",
                    display: "-webkit-box",
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    mt: 0.5,
                  }}
                >
                  {product?.description}
                </Typography>
              )}
              {product?.price?.discounted && (
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: colors.textColor2,
                    fontFamily: "Poppins-Light",
                    mt: 1.5,
                  }}
                >
                  {product?.price?.discounted} {" " + product?.price?.currency}
                </Typography>
              )}
              <Typography
                sx={{
                  fontSize: product?.price?.discounted ? "10px" : "12px",
                  color: colors.textColor2,
                  fontFamily: "Poppins-ExtraLight",
                  textDecorationLine: product?.price?.discounted
                    ? "line-through"
                    : "none",
                }}
              >
                {product?.price?.original || "N/A"}{" "}
                {product?.price?.currency || ""}
              </Typography>
            </CardContent>
          </Card>
          {/* <Box
            sx={{
              height: "max-content",
              borderRadius: "15px",
              backgroundColor: "#fff",
              boxShadow: "0px 0px 4px 0px #0000001A",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              mt: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins-SemiBold",
                color: "#000",
                fontSize: "14px",
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
              }}
            >
              {product?.attributes}
            </Typography>
          </Box> */}
        </Stack>
      ))}

      {isWeb && (
        <IconButton
          onClick={scrollRight}
          sx={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: "white",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
            "&:hover": { backgroundColor: "#f1f1f1" },
          }}
        >
          <ArrowForwardIos fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default ProductCards;
